import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import { useAiAssistantTemplatesCacheUpdater } from "../../SectionsSettingsAiAssistantTemplatesPage/useFetchAiAssistantTemplates";
import { useAiAssistantTemplateCacheUpdater } from "./useFetchAiAssistantTemplate";

export const useDeleteAiAssistantTemplate = ({
  sectionId,
  templateId,
}: {
  sectionId: string;
  templateId: string;
}) => {
  const { removeAiAssistantTemplate: removeFromList } =
    useAiAssistantTemplatesCacheUpdater();
  const { removeAiAssistantTemplate: removeDetailCache } =
    useAiAssistantTemplateCacheUpdater();

  return useBoronMutation(
    async () =>
      await boronClient.DELETE(
        "/api/v1/sections/{section_id}/ai_assistant_templates/{id}",
        {
          params: {
            path: {
              section_id: sectionId,
              id: Number(templateId),
            },
          },
        },
      ),
    {
      onSuccess: () => {
        removeFromList(sectionId, Number(templateId));
        removeDetailCache(sectionId, templateId);
      },
    },
  );
};
